import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { PaymentInfo } from 'actions/actionTypes';
import * as actions from 'actions/billing/paymentInfo';

import { callShopBillReceiveInfo } from 'network/apis/billing/paymentInfo';

function* loadShopBillReceiveInfoRequestSaga() {
    try {
        const response = yield call(callShopBillReceiveInfo);

        yield put(actions.loadShopBillReceiveInfoSuccess(response.data));
    } catch(error) {
        yield put(actions.loadShopBillReceiveInfoFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(PaymentInfo.LOAD_SHOP_BILL_RECEIVE_INFO_REQUEST, loadShopBillReceiveInfoRequestSaga),
    ]);
}